import { CohortHelpers } from './cohort.helpers';

export const COHORT_CONFIG = {
  msCountdownThreshold: CohortHelpers.getHoursInMs(2),
  msPollInterval: CohortHelpers.getMinutesInMs(2),
  msPollStartBuffer: CohortHelpers.getMinutesInMs(10),
};

export type COHORT_CONFIG_TYPE = typeof COHORT_CONFIG;



// WEBPACK FOOTER //
// ./ts/app/home/cohort/cohort.config.ts